<div class="d-flex justify-content-center flex h-100 overflow-auto w-100 p-4">
    <div class="mt-5 text-center" style="width: fit-content;">
        <h1 class="text-36-600-133 text-c4">
            {{'Let’s Begin!' | translate}}
            <img class="ms-3" src="assets/icons/rocket.svg" alt="">
        </h1>
        <p class="mt-4 mb-5 text-20-500-140 text-c2">{{'Select Category, Questions, and Teams' | translate}}</p>
        <app-game-settings (submission)="onGameSettingsChange($event)" ></app-game-settings>
    </div>
</div>
